<span class="icon-button-wrapper">
  <span class="icon" [ngClass]="['cmx-icon-' + icon]"></span>
</span>
<span class="icon-button-focus"></span>
<ng-content></ng-content>
